/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  "'Goals.CreateGoal.footer.create-label": 'Opret',
  'Goals.CreateGoal.EditMetric.header': 'Rediger måling',
  'Goals.CreateGoal.create.error': 'Kunne ikke oprette mål',
  'Goals.CreateGoal.create.network.error': 'Forbindelsen mislykkedes',
  'Goals.CreateGoal.create.permission.error': 'Du har ikke den nødvendige tilladelse til at oprette et mål.',
  'Goals.CreateGoal.error.description': 'Der gik noget galt. Kontrollér din internetforbindelse, og prøv igen.',
  'Goals.CreateGoal.error.header': 'Kunne ikke oprette mål',
  'Goals.CreateGoal.footer.cancel-label': 'Annuller',
  'Goals.CreateGoal.form.icon.back-button-label': 'Tilbage',
  'Goals.CreateGoal.form.name.error': 'Du skal angive et målnavn',
  'Goals.CreateGoal.form.name.label': 'Navn',
  'Goals.CreateGoal.form.owner.error': 'Ejer skal udfyldes.',
  'Goals.CreateGoal.header': 'Opret mål',
  'Goals.CreateGoal.parent-goal-label': 'Overordnet mål',
  'Goals.CreateGoal.parent-goal.error': 'Overordnet mål skal udfyldes.',
  'Goals.CreateGoal.required-fields-are-marked': 'Obligatoriske felter er markeret med stjerne <asterisk></asterisk>',
  'Goals.CreateGoal.site-label': 'Website',
  'Goals.CreateGoal.type-label': 'Type',
  'Goals.CreateGoal.type-label-placeholder': 'Hvad skal vi kalde det?',
  'Goals.CreateMetric.add-metric-button': 'Tilføj måling',
  'Goals.CreateMetric.metric-select.create-new': 'Opret ny måling',
  'Goals.CreateMetric.metric-select.use-existing': 'Brug eksisterende måling',
  'Goals.CreateMetric.metric-start-value.label': 'Startværdi',
  'Goals.CreateMetric.metric-target-value.label': 'Målværdi',
  'Goals.CreateMetric.metric-unit-select.label': 'Enhed',
  'Goals.GoalCreationModal.label.date-selection-placeholder': 'Vælg en dato',
  'Goals.GoalCreationModal.label.date-selection-title': 'Måldato',
  'Goals.GoalCreationModal.label.owner-picker-placeholder': 'Indtast person',
  'Goals.GoalCreationModal.label.owner-selection-title': 'Ejer',
  'townsquare.api.goal-type-description.goal': 'Generelle mål',
  'townsquare.api.goal-type-description.key-result': 'Den kvantitative måde at måle et mål på (OKR-ramme).',
  'townsquare.api.goal-type-description.objective': 'Det ønskede resultat (OKR-ramme).',
};
